<template>
    <div class="store-menu-component">
        <div class="store-side-menu d-none d-sm-none d-md-none d-lg-inline-block">
            <div class="store-menu">
                <div class="sort">
                    <strong class="text-uppercase font-weight-bold">Sort By</strong>
                    <select name="sort" id="sort" class="form-control" @change="getSort" v-model="sort">
                        <option value="" selected>Please select</option>
                        <option value="0">Alphabetical (A-Z)</option>
                        <option value="1">Alphabetical (Z-A)</option>
                        <option value="2">Price (Low to High)</option>
                        <option value="3">Price (High to Low)</option>
                        <option value="4">Oldest to Newest</option>
                        <option value="5">Newest to Oldest</option>
                    </select>
                </div>

                <div class="product-categories mt-4">
                    <div class="product-menu">
                        <strong class="text-uppercase font-weight-bold">Types</strong>
                        <i class="fas fa-angle-right float-right"></i>
                        <i class="fas fa-angle-down float-right d-none"></i>
                    </div>
                    <div class="product-type-title">Products</div>
                    <div class="product-types">
                        <div class="indented-menu"><a href="/store" :class="categoryName === 'store' ? 'active' : ''">All</a></div>
                        <div class="indented-menu" v-for="(item, index) in menuItems" :key="index">
                            <a :href="`/products/${item.slug}`" :class="categoryName === item.slug ? 'active' : ''">{{ item.name }}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Menu',
    data() {
        return {
            sort: ''
        }
    },
    props: {
        menuItems: Array
    },
    computed: {
        categoryName() {
        return window.location.pathname.split('/').pop();
        }
    },
    methods: {
        getSort() {
        this.$emit('get-sort', this.sort);
        }
    }
}
</script>

<style lang="sass" scoped>
.store-side-menu
    position: relative
    margin-top: 5rem
    a,
    a:visited
        color: $white
    a:hover,
    a:focus
        text-decoration: none
        color: $dutche-primary-violet
        font-weight: bold
        line-height: 1rem
    .store-menu
        z-index: 100
        position: absolute
        min-width: 300px
        background-color: $dutche-primary-yellow
        padding: 2rem
        border-top-right-radius: 1rem
        border-bottom-right-radius: 1rem
        color: $white
    .store-menu select
        background-color: $dutche-primary-yellow
        border: none
        color: $white
    .product-menu
        cursor: pointer
    .product-menu:hover,
    .product-menu:focus 
        color: $dutche-primary-violet
    .indented-menu 
        padding-left: 2rem
    .sort
        select
            border-top: solid 1px #fff
            border-bottom: solid 1px #fff
            border-radius: 0
    .product-type-title
        border-top: solid 1px #fff
        border-bottom: solid 1px #fff
        border-radius: 0
        padding: .375rem .75rem
        margin-bottom: .5rem

    .active
        color: $dutche-primary-violet !important
        font-weight: bold
</style>
